const state = {
  rules: {}, // Keyed by programId: { [programId]: [rules] }
  loading: false,
  error: null
}

const mutations = {
  SET_RULES (state, { programId, rules }) {
    // Sort by priority desc
    const sortedRules = rules.sort((a, b) => (b.priority || 0) - (a.priority || 0))
    state.rules = {
      ...state.rules,
      [programId]: sortedRules
    }
  },
  ADD_RULE (state, { programId, rule }) {
    const programRules = state.rules[programId] || []
    const newRules = [...programRules, rule].sort((a, b) => (b.priority || 0) - (a.priority || 0))
    state.rules = {
      ...state.rules,
      [programId]: newRules
    }
  },
  UPDATE_RULE (state, { programId, rule }) {
    const programRules = state.rules[programId] || []
    const index = programRules.findIndex(r => r.id === rule.id)
    if (index !== -1) {
      programRules.splice(index, 1, rule)
      const sortedRules = programRules.sort((a, b) => (b.priority || 0) - (a.priority || 0))
      state.rules = {
        ...state.rules,
        [programId]: sortedRules
      }
    }
  },
  REMOVE_RULE (state, { programId, ruleId }) {
    const programRules = state.rules[programId] || []
    state.rules = {
      ...state.rules,
      [programId]: programRules.filter(r => r.id !== ruleId)
    }
  },
  SET_LOADING (state, loading) {
    state.loading = loading
  },
  SET_ERROR (state, error) {
    state.error = error
  }
}

const actions = {
  async fetchRules ({ commit }, programId) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const rules = await this._vm.$loyaltyService.getEarningRules(programId)
      commit('SET_RULES', { programId, rules })
      return rules
    } catch (error) {
      commit('SET_ERROR', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createRule ({ commit }, data) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const rule = await this._vm.$loyaltyService.createEarningRule(data)
      commit('ADD_RULE', { programId: data.loyalty_program_id, rule })
      return rule
    } catch (error) {
      commit('SET_ERROR', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateRule ({ commit }, { id, data }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const rule = await this._vm.$loyaltyService.updateEarningRule(id, data)
      commit('UPDATE_RULE', { programId: data.loyalty_program_id || rule.loyalty_program_id, rule })
      return rule
    } catch (error) {
      commit('SET_ERROR', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteRule ({ commit }, { id, programId }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      await this._vm.$loyaltyService.deleteEarningRule(id)
      commit('REMOVE_RULE', { programId, ruleId: id })
      return true
    } catch (error) {
      commit('SET_ERROR', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const getters = {
  rulesByProgram: state => programId => {
    return state.rules[programId] || []
  },
  activeRulesByProgram: state => programId => {
    const rules = state.rules[programId] || []
    return rules.filter(r => r.is_active)
  },
  loading: state => state.loading,
  error: state => state.error
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
